import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationComponent } from './components/navigation/navigation.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [NavigationComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = $localize`AlbCode - Software & Webentwicklung Saliger. Ihr Partner für maßgeschneiderte Software- und Webprojekte.`;
}
